const closeSvg = `
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 10.9163L2.29278 17.6236C2.04182 17.8745 1.72243 18 1.3346 18C0.946768 18 0.627376 17.8745 0.376425 17.6236C0.125475 17.3726 0 17.0532 0 16.6654C0 16.2776 0.125475 15.9582 0.376425 15.7072L7.08365 9L0.376425 2.29278C0.125475 2.04182 0 1.72243 0 1.3346C0 0.946768 0.125475 0.627376 0.376425 0.376425C0.627376 0.125475 0.946768 0 1.3346 0C1.72243 0 2.04182 0.125475 2.29278 0.376425L9 7.08365L15.7072 0.376425C15.9582 0.125475 16.2776 0 16.6654 0C17.0532 0 17.3726 0.125475 17.6236 0.376425C17.8745 0.627376 18 0.946768 18 1.3346C18 1.72243 17.8745 2.04182 17.6236 2.29278L10.9163 9L17.6236 15.7072C17.8745 15.9582 18 16.2776 18 16.6654C18 17.0532 17.8745 17.3726 17.6236 17.6236C17.3726 17.8745 17.0532 18 16.6654 18C16.2776 18 15.9582 17.8745 15.7072 17.6236L9 10.9163Z" fill="black"/>
</svg>`;

const wrapperSvg = `
<svg width="239" height="239" viewBox="0 0 239 239" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M168.458 237H202.729C211.818 237 220.535 233.389 226.962 226.962C233.389 220.535 237 211.818 237 202.729V168.458M237 70.5417V36.2708C237 27.1816 233.389 18.4647 226.962 12.0377C220.535 5.61067 211.818 2 202.729 2H168.458M70.5417 237H36.2708C27.1816 237 18.4647 233.389 12.0377 226.962C5.61067 220.535 2 211.818 2 202.729V168.458M2 70.5417V36.2708C2 27.1816 5.61067 18.4647 12.0377 12.0377C18.4647 5.61067 27.1816 2 36.2708 2H70.5417" stroke="#281238" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

class QRCodeScanner {
  constructor() {
    this.video = null;
    this.galleryImageData = null;
    this.galleryImage = null; // 保存原始图片对象
    this.canvas = null;
    this.context = null;
    this.stream = null;
    this.isScanning = false;
    this.scanInterval = null;
    this.galleryScanInterval = null;
    this.galleryScanStartTime = null;
    this.galleryScanAttempt = 0; // 当前尝试次数
    this.modal = null;
    this.onSuccess = null;
    this.onError = null;
  }

  // 创建扫码弹框
  createModal() {
    const modal = document.createElement("div");
    modal.className = "scan-modal";
    modal.innerHTML = `
    <div class="scan-modal-content">
      <div class="scan-header">
        <div class="scan-close">${closeSvg}</div>
      </div>
      <div class="scan-container">
        <div class="scan-overlay">
            ${wrapperSvg}
          <div class="scan-line">
           </div>
           <video class="scan-video" autoplay muted playsinline></video>
        </div>
        <div class="scan-status">Camera Started</div>
      </div>
      </div>
    `;

    document.body.appendChild(modal);
    this.modal = modal;

    // 绑定事件
    this.bindEvents();

    return modal;
  }

  // 绑定事件
  bindEvents() {
    const closeBtn = this.modal.querySelector(".scan-close");

    closeBtn.addEventListener("click", () => this.close());

    // 点击背景关闭
    this.modal.addEventListener("click", (e) => {
      if (e.target === this.modal) {
        this.close();
      }
    });
  }

  // 打开扫码弹框
  open(onSuccess, onError) {
    this.onSuccess = onSuccess;
    this.onError = onError;

    if (!this.modal) {
      this.createModal();
    }

    this.modal.classList.add("active");
    this.preventBodyScroll();
    this.startCamera();
  }

  // 关闭扫码弹框
  close() {
    if (this.modal) {
      this.modal.classList.remove("active");
    }
    this.restoreBodyScroll();
    this.stopCamera();
  }

  // 开始摄像头
  async startCamera() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: "environment", // 后置摄像头
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });

      this.video = this.modal.querySelector(".scan-video");
      this.video.srcObject = this.stream;

      this.video.addEventListener("loadedmetadata", () => {
        this.setupCanvas();
        this.startScanning();
      });

      this.isScanning = true;
      this.updateStatus("Camera started");
    } catch (error) {
      console.error("Camera startup failed:", error);
      this.updateStatus("Camera startup failed");
      if (this.onError) {
        this.onError(error);
      }
    }
  }

  // 停止摄像头
  stopCamera() {
    this.isScanning = false;

    if (this.scanInterval) {
      clearInterval(this.scanInterval);
      this.scanInterval = null;
    }

    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
      this.stream = null;
    }

    if (this.video) {
      this.video.srcObject = null;
    }
  }

  // 设置画布
  setupCanvas() {
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext("2d");

    // 设置画布尺寸
    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;
  }

  // 开始扫描
  startScanning() {
    if (!this.isScanning) return;

    this.scanInterval = setInterval(() => {
      this.scanFrame();
    }, 1000); // 每1000ms扫描一次
  }

  // 扫描帧
  scanFrame() {
    if (!this.video || !this.context || !this.isScanning) return;

    try {
      // 绘制当前帧到画布
      this.context.drawImage(
        this.video,
        0,
        0,
        this.canvas.width,
        this.canvas.height
      );

      // 获取图像数据
      const imageData = this.context.getImageData(
        0,
        0,
        this.canvas.width,
        this.canvas.height
      );

      // 使用 jsQR 库解码
      if (typeof jsQR !== "undefined") {
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) {
          this.updateStatus("Scan successful!");
          this.stopCamera();
          this.close();

          if (this.onSuccess) {
            this.onSuccess(code.data);
          }
        }
      }
    } catch (error) {
      console.error("扫描错误:", error);
    }
  }

  // 开始相册图片扫描
  startGalleryScanning() {
    if (!this.galleryImage) return;

    this.galleryScanStartTime = Date.now();
    this.galleryScanAttempt = 0; // 重置尝试次数
    const maxDuration = 5000; // 5秒

    this.galleryScanInterval = setInterval(() => {
      // 先检查是否已经成功（如果成功，galleryImage 会被清除）
      if (!this.galleryImage) {
        // 已经成功，清除定时器
        if (this.galleryScanInterval) {
          clearInterval(this.galleryScanInterval);
          this.galleryScanInterval = null;
        }
        return;
      }
      
      this.scanGalleryImage();
      
      // 再次检查是否已经成功（scanGalleryImage 可能已经成功并清除了 galleryImage）
      if (!this.galleryImage) {
        // 已经成功，清除定时器
        if (this.galleryScanInterval) {
          clearInterval(this.galleryScanInterval);
          this.galleryScanInterval = null;
        }
        return;
      }
      
      // 检查是否超过5秒（只有在还没成功的情况下才检查）
      if (Date.now() - this.galleryScanStartTime >= maxDuration) {
        this.stopGalleryScanning();
        this.hideLoading();
        
        // 显示错误提示
        const lang = document.documentElement.getAttribute('lang') || 'en';
        const errorMessage = lang === 'ja' 
          ? 'QRコードが見つかりませんでした。別の画像を選択してください。'
          : lang === 'zh'
          ? '未检测到二维码，请选择其他图片'
          : 'No QR code detected, please select another image';
        
        // 使用 Message.error 显示错误提示
        if (typeof Message !== 'undefined') {
          Message.error(errorMessage, 2000);
        }
      }
    }, 1000); // 每1000ms扫描一次，和摄像头一样
  }

  // 扫描相册图片（参考 test.html 的实现）
  scanGalleryImage() {
    if (!this.galleryImage) return;

    try {
      if (typeof jsQR !== "undefined") {
        // 根据尝试次数调整缩放比例（参考 test.html）
        let scale = 1;
        if (this.galleryScanAttempt === 1) {
          scale = 0.7; // 第二次尝试缩小尺寸
        } else if (this.galleryScanAttempt === 2) {
          scale = 1.5; // 第三次尝试放大尺寸
        } else if (this.galleryScanAttempt >= 3) {
          // 后续尝试使用原始尺寸
          scale = 1;
        }

        const img = this.galleryImage;
        const actualWidth = img.naturalWidth || img.width;
        const actualHeight = img.naturalHeight || img.height;

        let width = Math.floor(actualWidth * scale);
        let height = Math.floor(actualHeight * scale);

        // 确保最小尺寸
        const minSize = 100;
        if (width < minSize) width = minSize;
        if (height < minSize) height = minSize;

        // 确保最大尺寸
        const maxSize = 2000;
        if (width > maxSize || height > maxSize) {
          const sizeScale = Math.min(maxSize / width, maxSize / height);
          width = Math.floor(width * sizeScale);
          height = Math.floor(height * sizeScale);
        }

        // 创建画布处理图片
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = width;
        canvas.height = height;

        // 调整渲染质量
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        // 绘制图片到画布
        ctx.drawImage(img, 0, 0, width, height);

        // 获取图像数据
        const imageData = ctx.getImageData(0, 0, width, height);

        // 验证图像数据
        if (!imageData || !imageData.data || imageData.data.length === 0) {
          console.error("无效的图像数据");
          this.galleryScanAttempt++;
          return;
        }

        // 检查数据长度是否匹配
        const expectedLength = width * height * 4;
        if (imageData.data.length !== expectedLength) {
          console.error(`图像数据长度不匹配 (${imageData.data.length} != ${expectedLength})`);
          this.galleryScanAttempt++;
          return;
        }

        // 根据尝试次数调整识别参数（参考 test.html）
        const options = {
          inversionAttempts: "attemptBoth",
        };

        // 尝试解码
        const code = jsQR(imageData.data, width, height, options);

        if (code) {
          this.stopGalleryScanning();
          this.hideLoading();
          
          // 将扫描结果填入输入框
          const qrcodeInput = document.getElementById("qrcode-input");
          if (qrcodeInput) {
            if (code.data.split("$")[2]) {
              qrcodeInput.value = code.data.split("$")[2];
            } else {
              qrcodeInput.value = code.data;
            }
            // 触发输入事件
            qrcodeInput.dispatchEvent(new Event("input", { bubbles: true }));
            const clickBtn = document.getElementById('iccid-search')
            if (clickBtn) {
              clickBtn.click()
            }
          }

          if (this.onSuccess) {
            this.onSuccess(code.data);
          }
        } else {
          // 增加尝试次数，下次使用不同的参数
          this.galleryScanAttempt++;
        }
      }
    } catch (error) {
      console.error("Gallery scan error:", error);
      this.galleryScanAttempt++;
    }
  }

  // 停止相册图片扫描
  stopGalleryScanning() {
    if (this.galleryScanInterval) {
      clearInterval(this.galleryScanInterval);
      this.galleryScanInterval = null;
    }
    this.galleryImageData = null;
    this.galleryImage = null;
    this.galleryScanStartTime = null;
    this.galleryScanAttempt = 0;
  }

  // 从相册选择
  selectFromGallery() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = false;

    input.addEventListener("change", (e) => {
      const file = e.target.files[0];
      if (file) {
        // 先停止之前的扫描
        this.stopGalleryScanning();
        this.showLoading();
        this.processImageFile(file);
      }
    });
    input.click();
  }

  // 显示 loading 弹窗
  showLoading() {
    // 如果已经有 loading 弹窗，直接返回
    let loadingModal = document.getElementById("gallery-loading-modal");

    if (!loadingModal) {
      loadingModal = document.createElement("div");
      loadingModal.id = "gallery-loading-modal";
      loadingModal.className = "gallery-loading-modal";

      const lang = document.documentElement.getAttribute("lang") || "en";
      const loadingText =
        lang === "ja"
          ? "画像を処理中..."
          : lang === "zh"
          ? "正在处理图片..."
          : "Processing image...";

      loadingModal.innerHTML = `
        <div class="gallery-loading-overlay"></div>
        <div class="gallery-loading-content">
          <div class="gallery-loading-spinner"></div>
          <div class="gallery-loading-text">${loadingText}</div>
        </div>
      `;

      document.body.appendChild(loadingModal);
    }

    loadingModal.classList.add("active");
    this.preventBodyScroll();
  }

  // 隐藏 loading 弹窗
  hideLoading() {
    const loadingModal = document.getElementById("gallery-loading-modal");
    if (loadingModal) {
      loadingModal.classList.remove("active");
    }
    this.restoreBodyScroll();
  }

  // 处理图片文件

  processImageFile(file) {
    // 创建对象URL
    const objectURL = URL.createObjectURL(file);

    const img = new Image();
    // 使用箭头函数保持 this 上下文
    img.onload = () => {
      // 释放对象URL，避免内存泄漏
      URL.revokeObjectURL(objectURL);

      try {
        // 保存原始图片对象，用于后续不同尺寸的尝试（参考 test.html）
        this.galleryImage = img;
        this.galleryScanAttempt = 0; // 重置尝试次数
    

        // 开始循环扫描，每次尝试使用不同的尺寸和参数
        this.startGalleryScanning();
      } catch (error) {
        console.error("Error processing image:", error);
        this.stopGalleryScanning();
        this.hideLoading();
        if (this.onError) {
          this.onError(new Error(`Image processing failed: ${error.message}`));
        }
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(objectURL);
      console.error("Image load error");
      // 图片加载失败
      this.stopGalleryScanning();
      this.hideLoading();
      if (this.onError) {
        this.onError(new Error("Failed to load image"));
      }
    };

    img.src = objectURL;
  }

  // 更新状态
  updateStatus(message) {
    const statusEl = this.modal.querySelector(".scan-status");
    if (statusEl) {
      statusEl.textContent = message;
    }
  }

  // 防止页面滚动
  preventBodyScroll() {
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.height = "100%";
  }

  // 恢复页面滚动
  restoreBodyScroll() {
    document.body.style.overflow = "";
    document.body.style.position = "";
    document.body.style.width = "";
    document.body.style.height = "";
  }
}

// 全局扫码器实例
window.qrScanner = new QRCodeScanner();

// 初始化扫码功能
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".camera-input");
  if (!btn) return;
  btn.addEventListener("click", function (e) {
    e.preventDefault();

    // 扫码成功回调
    const onSuccess = (qrData) => {
      // 将扫描结果填入输入框
      const iccidInput = document.getElementById("qrcode-input");
      if (iccidInput) {
        if (qrData.split("$")[2]) {
          iccidInput.value = qrData.split("$")[2];
        }
        iccidInput.dispatchEvent(new Event("input", { bubbles: true }));
        const clickBtn = document.getElementById('iccid-search')
        if (clickBtn) {
          clickBtn.click()
        }
      }
    };

    // 扫码失败回调
    const onError = (error) => {
      console.error("QR scan failed:", error);
      alert(
        "QR scan failed, please check camera permissions or enter manually"
      );
    };

    // 打开扫码弹框
    window.qrScanner.open(onSuccess, onError);
  });
});
